import React from "react";
import {
  clearAddToBasketMessage,
  clearInfoMessage,
  clearSuccessMessage,
} from "../../app/store/alerts/alertsActions";
import { connect } from "react-redux";
import { State } from "../../app/store";
import AddToBasketAlerts from "./AddToBasket";
import InfoAlerts from "./InfoAlerts";
import SuccessAlerts from "./SuccessAlerts";

interface IProps {
  alerts: {
    addToBasket: string | null;
    info: string[] | null;
    success: string | null;
  };
  clearAddToBasketMessage: Function;
  clearInfoMessage: Function;
  clearSuccessMessage: Function;
}

export const AlertsHandler: React.FC<IProps> = ({
  alerts,
  clearAddToBasketMessage,
  clearInfoMessage,
  clearSuccessMessage,
}: IProps) => {
  return (
    <>
      <AddToBasketAlerts info={alerts.addToBasket} onHide={clearAddToBasketMessage} />
      <InfoAlerts info={alerts.info} onHide={clearInfoMessage} />
      <SuccessAlerts successText={alerts.success} onHide={clearSuccessMessage} />
    </>
  );
};

const mapStateToProps = (state: State) => ({
  alerts: state.alerts,
});

export default connect(mapStateToProps, {
  clearAddToBasketMessage,
  clearInfoMessage,
  clearSuccessMessage,
})(AlertsHandler);
